import { ReactNode } from "react";
import {
  iconBadgeStyle,
  rowDescriptionStyle,
  rowLabelStyle,
} from "../style";

interface SettingsRowProps {
  icon: ReactNode;
  title: string;
  description: string;
  control: ReactNode;
}

const SettingsRow = ({ icon, title, description, control }: SettingsRowProps) => {
  return (
    <div className="d-flex align-items-center gap-3 p-3">
      <div style={iconBadgeStyle}>{icon}</div>
      <div className="flex-grow-1">
        <h6 className="mb-0 fw-semibold" style={rowLabelStyle}>
          {title}
        </h6>
        <p className="mb-0 text-muted" style={rowDescriptionStyle}>
          {description}
        </p>
      </div>
      {control}
    </div>
  );
};

export default SettingsRow;
